'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getLine = exports.getLine = function getLine(plain, cursorPos) {
    var endSlice = plain.slice(cursorPos);
    var startSlice = plain.slice(0, cursorPos);
    var lastNewline = startSlice.lastIndexOf('\n') + 1;

    var endNewline = endSlice.indexOf('\n') + 1;
    endNewline = endNewline === 0 ? plain.length : endNewline;

    return startSlice.slice(lastNewline) + endSlice.slice(0, endNewline);
};

var getLineRange = exports.getLineRange = function getLineRange(plain, cursorPos) {
    var endSlice = plain.slice(cursorPos);
    var startSlice = plain.slice(0, cursorPos);
    var lastNewline = startSlice.lastIndexOf('\n') + 1;

    var endNewline = endSlice.indexOf('\n') + 1;
    endNewline = endNewline === 0 ? plain.length : endNewline;

    var prefix = startSlice.slice(lastNewline);
    var suffix = endSlice.slice(0, endNewline);

    return [cursorPos - prefix.length, cursorPos + suffix.length];
};

var getBeforeLine = exports.getBeforeLine = function getBeforeLine(plain, cursorPos) {
    var startSlice = plain.slice(0, cursorPos);
    var lastNewline = startSlice.lastIndexOf('\n') + 1;
    return startSlice.slice(lastNewline);
};

var indentRe = /^\s+/;

var getIndent = exports.getIndent = function getIndent(plain, cursorPos) {
    var line = getBeforeLine(plain, cursorPos);
    var matches = line.match(indentRe);
    if (matches === null) {
        return '';
    }

    return matches[0] || '';
};

var deindentSpacesRe = /^(\t|  )*  $/;

var getDeindentLevel = exports.getDeindentLevel = function getDeindentLevel(plain, cursorPos) {
    var tabSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;

    var line = getBeforeLine(plain, cursorPos);
    if (!deindentSpacesRe.test(line)) {
        return 0; // Doesn't match regex, so normal behaviour can apply
    }

    // The line contains only whitespace indentation
    // thus two characters must be deleted
    return tabSize;
};


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/utils/getIndent.js